import api from 'Application/api/api';

const deleteInvoice = (signal, deletedInvoiceId) =>
	api.delete(`/invoices/${deletedInvoiceId}`, {
		signal,
	});

export default deleteInvoice;
